<template>
  <div class="row layout-spacing dashboard-analitics">

    <!-- COUNTERS -->
    <div class=" col-lg-6 col-md-6 col-sm-6 col-xl-4">
      <div class="widget-content-area data-widgets br-4">
        <div class="widget t-income-widget">
          <div class="media d-block text-center">
            <div class="icon mb-2">
              <i class="flaticon-user-11"></i>
            </div>
            <div class="media-body text-center">
              <p class="widget-text mb-0">إجمالى عدد الطلاب</p>
              <p class="widget-numeric-value mb-0 numeric-value-1">{{ data.students }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-4 mb-xl-0 col-lg-6 mb-4 col-md-6 col-sm-6">
      <div class="widget-content-area data-widgets br-4">
        <div class="widget t-order-widget">
          <div class="media d-block text-center">
            <div class="icon mb-2">
              <i class="flaticon-cart-bag"></i>
            </div>
            <div class="media-body text-center">
              <p class="widget-text mb-0">إجمالى عدد الحلقات</p>
              <p class="widget-numeric-value mb-0 numeric-value-2">{{ data.lessons }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class=" col-lg-6 col-md-6 col-sm-6 col-xl-4">
      <div class="widget-content-area data-widgets br-4">
        <div class="widget t-income-widget">
          <div class="media d-block text-center">
            <div class="icon mb-2">
              <i class="flaticon-user-11"></i>
            </div>
            <div class="media-body text-center">
              <p class="widget-text mb-0">إجمالى عدد المعلمين</p>
              <p class="widget-numeric-value mb-0 numeric-value-3">{{ data.teachers }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-4 col-lg-6 col-md-6 col-sm-6 col-xl-4">
      <div class="widget-content-area data-widgets br-4">
        <div class="widget t-income-widget">
          <div class="media d-block text-center">
            <div class="icon mb-2">
              <i class="flaticon-user-11"></i>
            </div>
            <div class="media-body text-center">
              <p class="widget-text mb-0">إجمالى عدد أولياء الأمور</p>
              <p class="widget-numeric-value mb-0 numeric-value-4">{{ data.parents }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-4 col-xl-4 mb-xl-0 col-lg-6 mb-4 col-md-6 col-sm-6">
      <div class="widget-content-area data-widgets br-4">
        <div class="widget t-income-widget">
          <div class="media d-block text-center">
            <div class="icon mb-2">
              <i class="flaticon-line-chart"></i>
            </div>
            <div class="media-body text-center">
              <p class="widget-text mb-0">إجمالى عدد المراحل</p>
              <p class="widget-numeric-value mb-0 numeric-value-5">{{ data.stages }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-4 col-xl-4 mb-xl-0 col-lg-6 mb-4 col-md-6 col-sm-6">
      <div class="widget-content-area data-widgets br-4">
        <div class="widget t-sales-widget">
          <div class="media d-block text-center">
            <div class="icon mb-2">
              <i class="flaticon-line-chart"></i>
            </div>
            <div class="media-body text-center">
              <p class="widget-text mb-0">إجمالى عدد الصفوف</p>
              <p class="widget-numeric-value mb-0 numeric-value-6">{{ data.groups }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- DAILY STATS -->
    <div class="clearfix"></div>
    <div class="col-md-12 mt-4 mb-0">
      <div class="page-title">
        <h3 class="mb-0 pb-0">
          <i class="flaticon-computer-6" style="color: rgb(26, 115, 233);"></i>
          التردد اليومى
        </h3>
      </div>
    </div>

    <!-- TOTAL DONUT -->
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mt-4 mb-5">
      <div class="widget-content-area data-widgets br-4">
        <div class="widget t-sales-widget">
          <div class="media">
            إجمالى التردد اليومى للحلقات
          </div>
          <div class="media">
            <span class="text-success px-1">حضور: {{ data.totalStats.presence }}</span>
            <span class="text-danger px-1">غياب: {{ data.totalStats.absence }}</span>
            <span class="text-warning px-1">استئذان: {{ data.totalStats.excuse }}</span>
            <span class="text-primary px-1">تأخير: {{ data.totalStats.delay }}</span>
          </div>
        </div>

        <apexchart
          type="donut"
          width="100%"
          :options="chartOptions"
          :series="[
            makePerc(data.totalStats.presence, data.totalStats.total),
            makePerc(data.totalStats.absence, data.totalStats.total),
            makePerc(data.totalStats.excuse, data.totalStats.total),
            makePerc(data.totalStats.delay, data.totalStats.total)
          ]"
        />
      </div>
    </div>

    <!-- PER LESSON DONUTS -->
    <div
      class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mt-4 mb-5"
      v-for="(d, i) in data.lessonsStats"
      :key="i"
    >
      <div class="widget-content-area data-widgets br-4">
        <div class="widget t-sales-widget">
          <div class="media">
            {{ d.lesson_name }} - (المعلم: {{ d.teacher ? d.teacher.name : '---' }})
          </div>
          <div class="media">
            <span class="text-success px-1">حضور: {{ d.presence }}</span>
            <span class="text-danger px-1">غياب: {{ d.absence }}</span>
            <span class="text-warning px-1">استئذان: {{ d.excuse }}</span>
            <span class="text-primary px-1">تأخير: {{ d.delay }}</span>
          </div>
        </div>

        <apexchart
          v-if="!d.loading"
          type="donut"
          width="100%"
          :options="chartOptions"
          :series="[
            makePerc(d.presence, d.total),
            makePerc(d.absence, d.total),
            makePerc(d.excuse, d.total),
            makePerc(d.delay, d.total)
          ]"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import baseApi from "@/baseApi";

export default {
  data() {
    return {
      chartOptions: {
        chart: {
          type: "donut",
        },
        labels: ["الحضور", "الغياب", "الاستئذان", "التأخير"],
        colors: ["#0CAB4A", "#E53935", "#FBC02D", "#1E88E5"],
        legend: {
          position: "top",
          fontSize: "14px",
          markers: {
            width: 10,
            height: 10,
          },
        },
        plotOptions: {
          pie: {
            donut: {
              size: "75%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "الحضور",
                  fontSize: "18px",
                  color: "#0CAB4A",
                  formatter: function (w) {
                    return w.globals.series[0] + "%";
                  },
                },
                value: {
                  show: true,
                  fontSize: "36px",
                  fontWeight: 700,
                  color: "#0CAB4A",
                  formatter: function (val) {
                    return val + "%";
                  },
                },
              },
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return Math.round(val) + "%";
          },
          style: {
            fontSize: "14px",
            colors: ["#fff"],
          },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["#fff"],
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 250,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },

      data: {
        totalStats: {
          presence: 0,
          absence: 0,
          delay: 0,
          excuse: 0,
          total: 0,
        },
        lessonsStats: [],
        stages: 0,
        students: 0,
        parents: 0,
        teachers: 0,
        groups: 0,
        lessons: 0,
      },
    };
  },

  created() {
    this.getStates();
  },

  methods: {
    getStates() {
      baseApi().get("/home").then((response) => {
        if (response.data.code === 200) {
          this.data.students = response.data.data.studentCount;
          this.data.parents = response.data.data.parentCount;
          this.data.teachers = response.data.data.teacherCount;
          this.data.lessons = response.data.data.lessonCount;
          this.data.groups = response.data.data.groupCount;
          this.data.stages = response.data.data.stageCount;
          this.data.lessonsStats = response.data.data.dataStats;

          let vm = this;
          Object.keys(this.data.lessonsStats).forEach(function (key) {
            vm.getLessonDetails(key);
          });
        }
      });
    },

    getLessonDetails(lessonId) {
      baseApi().get("/get-lesson-stats?id=" + lessonId).then((response) => {
        if (response.data.code === 200) {
          let res = response.data.data;
          this.data.lessonsStats[lessonId] = res;
          this.data.totalStats.absence += res.absence;
          this.data.totalStats.presence += res.presence;
          this.data.totalStats.delay += res.delay;
          this.data.totalStats.excuse += res.excuse;
          this.data.totalStats.total += res.total;
        }
      });
    },

    makePerc(n, t) {
      if (n === 0 || t === 0) {
        return 0;
      }
      return Math.round((n / t) * 100);
    },
  },

  computed: {
    user() {
      return this.$store.getters.SET_AUTH_USER;
    },
  },
};
</script>

<style>
.apexcharts-legend-text {
  font-family: "Cairo", sans-serif;
}
</style>
